import React from 'react';
import { OrderItem } from '@restaurant/api';
import { formatCurrency } from '~/utils/currency';

const BaseItemRow = ({ item }: { item: OrderItem }) => {
  return (
    <div className="px-4 py-1">
      <div className="flex justify-between items-center">
        <span className="text-base font-semibold">
          {`${item.quantity} ${item.name}`}
        </span>
        <span>{formatCurrency(item.totalPrice)}</span>
      </div>
      {item.addOns?.map((addOn) => (
        <div className="flex justify-between items-center" key={addOn.menuId}>
          <span>{`${addOn.quantity} ${addOn.name}`}</span>
          <span>{formatCurrency(addOn.totalPrice)}</span>
        </div>
      ))}
      {item.notes ? <i className="text-xs">{item.notes}</i> : null}
    </div>
  );
};

export default BaseItemRow;
